import React from 'react';
import ReactDOM from 'react-dom';
import Workbench from './Workbench';

import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import {DialogPlaceholder} from "./common/Dialog";

import './index.css';

// This file serves as the entry point in which the Workbench application is bootstrapped.
ReactDOM.render(
  <React.StrictMode>
    <ReactNotification/>
    <Workbench/>
    <DialogPlaceholder/>
  </React.StrictMode>,
  document.querySelector('#root'));
